import { Skeleton } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import React, { FC } from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import { TeamMember } from "../../../interfaces";
import styles from "../../../styles/pages/our-team.module.scss";

const Info: FC<Props> = ({ member }) => {
  return (
    <>
      <Link href="/our-team" className={styles.backLink}>
        <MdKeyboardBackspace className={styles.backLinkIcon} />
        Back to Our Team
      </Link>
      {member ? (
        <div>
          <div className={styles.memberProfile}>
            <div className={styles.thumbnail}>
              <Image
                src={
                  member.cardImage ||
                  "/assets/images/class_thumbnail_placeholder.png"
                }
                alt={member.slug}
                width={175}
                height={175}
                layout="fixed"
              />
            </div>
            <div className={styles.descriptions}>
              <div className={styles.name}>{member.cardTitle}</div>
              {member.cardSubtitle}
            </div>
          </div>

          <div dangerouslySetInnerHTML={{ __html: member.cardDetailsHtml }} />
        </div>
      ) : (
        <div>
          <div className={`${styles.container} card`}>
            <div className="thumbnail">
              <Skeleton variant="rectangular" width={75} height={75} />
            </div>
            <div className="descriptions">
              <div className="name">
                <Skeleton variant="text" width={100} height={24} />
              </div>
              <Skeleton variant="text" width={150} height={16} />
            </div>
          </div>

          <div style={{ minHeight: "30vh" }}></div>
        </div>
      )}
    </>
  );
};

interface Props {
  member: TeamMember;
}

export default Info;
